/*
  Guia de tamanhos da Gummie: descobridor do número, régua e destaque na tabela.
  Usado na página do guia (sections/gummie-guia-tamanhos) e na aba "Guia de
  Tamanhos" da página de produto (snippets/gummie-guia-produto), que tem um
  modelo só e o botão "Selecionar o N" para marcar o tamanho no seletor.
*/
(() => {
  const NS = 'http://www.w3.org/2000/svg';
  const fmt1 = (n) => n.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const fmtCm = (mm) => (mm % 10 === 0 ? String(mm / 10) : (mm / 10).toLocaleString('pt-BR', { maximumFractionDigits: 1 }));
  const preencher = (texto, campos) => (texto || '').replace(/\[(\w+)\]/g, (t, k) => (k in campos ? campos[k] : t));

  // Foto do modelo: cada foto tem margens brancas diferentes. Mede onde o
  // produto está (pixels não brancos) e centraliza-o na moldura quadrada,
  // ocupando 86% dela. Sem acesso aos pixels, a foto fica só no contain.
  const enquadrar = (img) => {
    const medir = () => {
      try {
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;
        if (!nw || !nh) return;
        const w = 64;
        const h = Math.max(1, Math.round((w * nh) / nw));
        const tela = document.createElement('canvas');
        tela.width = w;
        tela.height = h;
        const g = tela.getContext('2d', { willReadFrequently: true });
        g.fillStyle = '#fff';
        g.fillRect(0, 0, w, h);
        g.drawImage(img, 0, 0, w, h);
        const px = g.getImageData(0, 0, w, h).data;
        let x0 = w;
        let y0 = h;
        let x1 = -1;
        let y1 = -1;
        for (let y = 0; y < h; y++) {
          for (let x = 0; x < w; x++) {
            const i = (y * w + x) * 4;
            if (px[i] < 235 || px[i + 1] < 235 || px[i + 2] < 235) {
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
        }
        if (x1 < 0) return;
        // Tamanho e posição da foto em contain, em frações da moldura
        const proporcao = nw / nh;
        const fw = Math.min(1, proporcao);
        const fh = Math.min(1, 1 / proporcao);
        const cx = (1 - fw) / 2 + ((x0 + x1 + 1) / 2 / w) * fw;
        const cy = (1 - fh) / 2 + ((y0 + y1 + 1) / 2 / h) * fh;
        const bw = ((x1 + 1 - x0) / w) * fw;
        const bh = ((y1 + 1 - y0) / h) * fh;
        const escala = Math.min(0.86 / bw, 0.86 / bh, 2.4);
        img.style.setProperty('--gt-arte-s', escala.toFixed(3));
        img.style.setProperty('--gt-arte-x', `${((0.5 - cx) * 100).toFixed(2)}%`);
        img.style.setProperty('--gt-arte-y', `${((0.5 - cy) * 100).toFixed(2)}%`);
      } catch (e) {
        // Foto sem CORS: o canvas fica bloqueado e a foto segue só centralizada
      }
    };
    if (img.complete && img.naturalWidth) medir();
    else img.addEventListener('load', medir, { once: true });
  };

  const iniciar = (raiz) => {
    if (!raiz || raiz.dataset.gtPronto === '1') return;
    raiz
      .querySelectorAll('.gt-modelo__arte:not(.gt-modelo__arte--dupla) img, .gt-tabela__arte:not(.gt-tabela__arte--dupla) img')
      .forEach(enquadrar);
    const fonte = raiz.querySelector('[data-gt-dados]');
    if (!fonte) return;
    let dados;
    try {
      dados = JSON.parse(fonte.textContent);
    } catch (e) {
      return;
    }

    // Os modelos chegam agrupados por público; i é a posição do bloco no editor
    const modelos = (dados.modelos || [])
      .slice()
      .sort((a, b) => a.i - b.i)
      .map((m) => {
        const linhas = (m.linhas || [])
          .map((l, i) => ({ numero: String(l.numero), mm: Math.round(Number(l.cm) * 10), i }))
          .filter((l) => l.mm > 0)
          .sort((a, b) => a.mm - b.mm);
        const medir = m.regra !== 'dia_a_dia' && linhas.length > 0;
        const menor = medir ? linhas[0].mm : 0;
        const maior = medir ? linhas[linhas.length - 1].mm : 0;
        let min;
        let max;
        let pe;
        if (m.regra === 'crianca') {
          min = Math.max(50, menor - 30);
          max = maior - 5;
          pe = Math.round((menor + maior) / 2) - 10;
        } else if (m.regra === 'pe') {
          min = Math.max(50, menor - 15);
          max = maior + 5;
          pe = Math.round((menor + maior) / 2);
        } else {
          min = Math.max(50, menor - 20);
          max = maior;
          pe = Math.round((menor + maior) / 2) - 10;
        }
        return { ...m, linhas, medir, menor, maior, min, max, pe: Math.min(max, Math.max(min, pe)), numero: '' };
      });
    if (!modelos.length) return;
    raiz.dataset.gtPronto = '1';

    const $ = (sel) => raiz.querySelector(sel);
    const radios = [...raiz.querySelectorAll('[data-gt-modelo]')];
    const publicos = [...raiz.querySelectorAll('[data-gt-publico]')];
    const blocoMedida = $('[data-gt-medida]');
    const blocoNumeros = $('[data-gt-numeros-bloco]');
    const listaNumeros = $('[data-gt-numeros]');
    const range = $('[data-gt-range]');
    const saidaValor = $('[data-gt-valor]');
    const regua = $('[data-gt-regua]');
    const parede = $('[data-gt-parede]');
    const escala = $('[data-gt-escala]');
    const pe = $('[data-gt-pe]');
    const palmilha = $('[data-gt-palmilha]');
    const marca = $('[data-gt-marca]');
    const folga = $('[data-gt-folga]');
    const folgaBarra = $('[data-gt-folga-barra]');
    const folgaTexto = $('[data-gt-folga-texto]');
    const selo = $('[data-gt-selo]');
    const numero = $('[data-gt-numero]');
    const texto = $('[data-gt-texto]');
    const botaoColecao = $('[data-gt-colecao]');
    const botaoWhats = $('[data-gt-whats]');
    const verTabela = $('[data-gt-ver-tabela]');
    const status = $('[data-gt-status]');
    const botaoSelecionar = $('[data-gt-selecionar]');
    // Opção de Tamanho do produto com esse número, procurada só na seção do produto
    const escopo = raiz.closest('.shopify-section') || document;
    const opcaoDoNumero = (n) => (n && n !== '?' ? escopo.querySelector(`[data-ma-native-option-value="${CSS.escape(n)}"]`) : null);
    const tabela = (i) => raiz.querySelector(`[data-gt-tabela="${i}"]`);

    let atual = Math.max(0, radios.findIndex((r) => r.checked));
    let geo = null;
    let ultimoNumero = '';

    const linkWhats = (msg) => (dados.whats ? `https://wa.me/${dados.whats}?text=${encodeURIComponent(msg)}` : '');

    // Régua do modelo: parede à esquerda, pé e palmilha com o calcanhar nela, escala em cm embaixo
    const desenharRegua = (m) => {
      const fim = Math.max(m.maior, m.max) + 12;
      const larg = fim + 18;
      const pxPorMm = regua.getBoundingClientRect().width / larg || 1.4;
      const fonteMm = 11.5 / pxPorMm;
      const topo = fonteMm + 12;
      const altPalmilha = 0.48 * Math.max(m.maior, m.max);
      const cy = topo + altPalmilha / 2;
      const yRegua = topo + altPalmilha + 12;
      const altRegua = Math.max(fonteMm * 2.1, 20);
      regua.setAttribute('viewBox', `-16 0 ${larg} ${yRegua + altRegua + 2}`);
      parede.setAttribute('y', 2);
      parede.setAttribute('height', yRegua + altRegua - 2);
      marca.querySelector('line').setAttribute('y2', yRegua);
      folgaTexto.style.fontSize = `${fonteMm}px`;

      escala.replaceChildren();
      const base = document.createElementNS(NS, 'rect');
      base.setAttribute('x', 0);
      base.setAttribute('y', yRegua);
      base.setAttribute('width', fim);
      base.setAttribute('height', altRegua);
      base.setAttribute('rx', 3);
      base.setAttribute('class', 'gt-regua__base');
      base.setAttribute('vector-effect', 'non-scaling-stroke');
      escala.append(base);
      const passoRotulo = 10 * pxPorMm >= 26 ? 10 : 20;
      for (let x = 5; x < fim; x += 5) {
        const cm = x % 10 === 0;
        const traco = document.createElementNS(NS, 'line');
        traco.setAttribute('x1', x);
        traco.setAttribute('x2', x);
        traco.setAttribute('y1', yRegua);
        traco.setAttribute('y2', yRegua + altRegua * (cm ? 0.38 : 0.22));
        traco.setAttribute('class', 'gt-regua__traco');
        traco.setAttribute('vector-effect', 'non-scaling-stroke');
        escala.append(traco);
        if (cm && x % passoRotulo === 0 && x < fim - 6) {
          const rotulo = document.createElementNS(NS, 'text');
          rotulo.setAttribute('x', x);
          rotulo.setAttribute('y', yRegua + altRegua * 0.86);
          rotulo.setAttribute('text-anchor', 'middle');
          rotulo.setAttribute('class', 'gt-regua__numero');
          rotulo.style.fontSize = `${fonteMm}px`;
          rotulo.textContent = x / 10;
          escala.append(rotulo);
        }
      }
      geo = { cy, fonteMm };
    };

    const posicionar = (peMm, rec) => {
      if (!geo) return;
      const { cy, fonteMm } = geo;
      pe.style.transform = `translate(0px, ${cy - 0.22 * peMm}px) scale(${peMm / 100})`;
      marca.style.transform = `translateX(${peMm}px)`;
      marca.querySelector('line').setAttribute('y1', cy - 0.105 * peMm);
      if (rec) {
        const s = rec.l.mm;
        const yFolga = cy - 0.24 * s - 7;
        palmilha.style.opacity = '1';
        palmilha.style.transform = `translate(0px, ${cy - 0.24 * s}px) scale(${s / 100})`;
        folga.style.opacity = s > peMm ? '1' : '0';
        folgaBarra.style.transform = `translate(${peMm}px, ${yFolga}px) scale(${Math.max(1, s - peMm)}, 1)`;
        folgaTexto.style.transform = `translate(${(peMm + s) / 2}px, ${yFolga - fonteMm * 0.35}px)`;
        folgaTexto.textContent = `+${s - peMm} mm`;
      } else {
        palmilha.style.opacity = '0';
        folga.style.opacity = '0';
      }
    };

    // Números do dia a dia (modelos sem tabela): as numerações do produto do bloco
    const montarNumeros = (m) => {
      listaNumeros.replaceChildren();
      (m.numeros || []).forEach((n) => {
        const rotulo = document.createElement('label');
        rotulo.className = 'gt-numero';
        const entrada = document.createElement('input');
        entrada.type = 'radio';
        entrada.name = `${raiz.id}-numero`;
        entrada.value = n;
        entrada.checked = m.numero === n;
        entrada.addEventListener('change', () => {
          if (!entrada.checked) return;
          m.numero = n;
          atualizar(true);
        });
        const span = document.createElement('span');
        span.textContent = n;
        rotulo.append(entrada, span);
        listaNumeros.append(rotulo);
      });
    };

    const atualizar = (anunciar) => {
      const m = modelos[atual];
      let rec = null;
      if (m.medir) {
        if (m.regra === 'crianca') {
          const alvo = m.pe + 10;
          const l = m.linhas.find((x) => x.mm >= alvo);
          if (l) rec = { l, alvo };
        } else if (m.regra === 'pe') {
          const l = m.linhas.find((x) => x.mm >= m.pe);
          if (l) rec = { l };
        } else {
          const folgaMin = Math.max(1, Number(dados.folgaMin) || 0);
          const l = m.linhas.find((x) => x.mm - m.pe >= folgaMin);
          if (l) rec = { l };
        }
        saidaValor.textContent = fmt1(m.pe / 10);
        if (Math.round(parseFloat(range.value) * 10) !== m.pe) range.value = (m.pe / 10).toFixed(1);
        range.setAttribute('aria-valuetext', `${fmt1(m.pe / 10)} centímetros`);
        range.style.setProperty('--gt-progresso', `${((m.pe - m.min) / Math.max(1, m.max - m.min)) * 100}%`);
        posicionar(m.pe, rec);
      }

      const medida = `${fmt1(m.pe / 10)} cm`;
      let num;
      let frase;
      let msg;
      if (!m.medir) {
        if (m.numero) {
          num = m.numero;
          frase = m.nota || '';
          msg = preencher(dados.msgNumero, { numero: m.numero, modelo: m.nome });
        } else {
          num = '?';
          frase = m.numeros && m.numeros.length
            ? `Toque no número que você usa no dia a dia (temos do ${m.numeros[0]} ao ${m.numeros[m.numeros.length - 1]}).`
            : m.nota || '';
          msg = preencher(dados.msgModelo, { modelo: m.nome });
        }
      } else if (!rec) {
        num = '?';
        frase = `Essa medida passou do maior número desta tabela (${m.linhas[m.linhas.length - 1].numero}).${dados.whats ? ' Fala com a gente no WhatsApp que a gente te ajuda a escolher.' : ''}`;
        msg = preencher(dados.msgMedida, { medida, modelo: m.nome });
      } else if (m.regra === 'crianca') {
        num = rec.l.numero;
        frase = `${fmt1(m.pe / 10)} cm + 1 cm pra crescer = ${fmt1(rec.alvo / 10)} cm. O ${rec.l.numero} tem palmilha de ${fmtCm(rec.l.mm)} cm.`;
        msg = preencher(dados.msgMedida, { medida, modelo: m.nome });
      } else if (m.regra === 'pe') {
        num = rec.l.numero;
        frase = `O ${rec.l.numero} serve pra pé de até ${fmtCm(rec.l.mm)} cm, e o seu tem ${fmt1(m.pe / 10)} cm.`;
        msg = preencher(dados.msgMedida, { medida, modelo: m.nome });
      } else {
        num = rec.l.numero;
        const sobra = rec.l.mm - m.pe;
        frase = `Palmilha de ${fmtCm(rec.l.mm)} cm: ${sobra === 1 ? 'sobra 1 mm' : `sobram ${sobra} mm`} na ponta, pro dedo não encostar.`;
        msg = preencher(dados.msgMedida, { medida, modelo: m.nome });
      }

      if (num !== ultimoNumero) {
        numero.textContent = num;
        numero.classList.toggle('gt-resultado__numero--texto', num.length > 6);
        if (ultimoNumero) {
          selo.classList.remove('gt-pop');
          void selo.offsetWidth;
          selo.classList.add('gt-pop');
        }
        ultimoNumero = num;
      }
      texto.textContent = frase;

      if (botaoColecao) {
        const temLink = Boolean(m.link && m.botao);
        botaoColecao.hidden = !temLink;
        if (temLink) {
          botaoColecao.href = m.link;
          botaoColecao.querySelector('span').textContent = m.botao;
        }
      }
      if (botaoWhats) botaoWhats.href = linkWhats(msg);
      // Página de produto: o botão marca o número indicado no seletor de Tamanho
      if (botaoSelecionar) {
        const opcao = opcaoDoNumero(num);
        botaoSelecionar.hidden = !opcao;
        if (opcao) {
          botaoSelecionar.dataset.gtNumero = num;
          botaoSelecionar.querySelector('span').textContent = `Selecionar o ${num}`;
        }
      }
      if (verTabela) verTabela.href = `#${raiz.id}-tabela-${atual}`;

      raiz.querySelectorAll('[data-gt-tabela]').forEach((t) => t.classList.toggle('is-ativa', t.dataset.gtTabela === String(atual)));
      raiz.querySelectorAll('.is-recomendado').forEach((el) => el.classList.remove('is-recomendado'));
      const cartao = tabela(atual);
      if (cartao && rec) {
        const linha = cartao.querySelector(`[data-gt-linha="${rec.l.i}"]`);
        if (linha) linha.classList.add('is-recomendado');
      }
      if (cartao && !m.medir && m.numero) {
        cartao.querySelectorAll('[data-gt-num]').forEach((li) => li.classList.toggle('is-recomendado', li.dataset.gtNum === m.numero));
      }

      if (anunciar && status) status.textContent = num !== '?' ? `Seu número: ${num}. ${frase}` : frase;
    };

    const trocarModelo = (i) => {
      atual = i;
      const m = modelos[atual];
      if (radios[i] && !radios[i].checked) radios[i].checked = true;
      blocoMedida.hidden = !m.medir;
      blocoNumeros.hidden = m.medir || !(m.numeros && m.numeros.length);
      regua.style.display = m.medir ? '' : 'none';
      if (m.medir) {
        range.min = (m.min / 10).toFixed(1);
        range.max = (m.max / 10).toFixed(1);
        range.value = (m.pe / 10).toFixed(1);
        desenharRegua(m);
      } else {
        montarNumeros(m);
      }
      atualizar(true);
    };

    // Pra quem é: mostra só os modelos daquele público
    const filtrarPublico = (publico, manterAtual) => {
      if (!publicos.length) return;
      radios.forEach((r) => {
        r.closest('[data-publico]').hidden = r.closest('[data-publico]').dataset.publico !== publico;
      });
      publicos.forEach((p) => {
        p.checked = p.value === publico;
      });
      if (!(manterAtual && modelos[atual].publico === publico)) {
        const primeiro = modelos.findIndex((m) => m.publico === publico);
        if (primeiro >= 0) trocarModelo(primeiro);
      }
    };

    radios.forEach((r, i) => r.addEventListener('change', () => r.checked && trocarModelo(i)));
    publicos.forEach((p) => p.addEventListener('change', () => p.checked && filtrarPublico(p.value, false)));
    range.addEventListener('input', () => {
      modelos[atual].pe = Math.round(parseFloat(range.value) * 10);
      atualizar(false);
    });
    range.addEventListener('change', () => atualizar(true));
    const ajustar = (d) => {
      const m = modelos[atual];
      m.pe = Math.min(m.max, Math.max(m.min, m.pe + d));
      atualizar(true);
    };
    $('[data-gt-menos]').addEventListener('click', () => ajustar(-1));
    if (botaoSelecionar) {
      botaoSelecionar.addEventListener('click', () => {
        const opcao = opcaoDoNumero(botaoSelecionar.dataset.gtNumero);
        if (!opcao) return;
        opcao.click();
        (opcao.closest('[data-ma-native-option-card]') || opcao).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    $('[data-gt-mais]').addEventListener('click', () => ajustar(1));

    if ('ResizeObserver' in window) {
      let largura = 0;
      new ResizeObserver((entradas) => {
        const nova = Math.round(entradas[0].contentRect.width);
        if (!nova || nova === largura) return;
        largura = nova;
        const m = modelos[atual];
        if (m.medir) {
          desenharRegua(m);
          atualizar(false);
        }
      }).observe(regua);
    }

    // ?tipo=<sufixo do template do produto> abre o guia já no modelo
    const tipo = new URLSearchParams(location.search).get('tipo');
    const pedido = tipo ? modelos.findIndex((m) => m.chave && m.chave === tipo) : -1;
    if (pedido >= 0) atual = pedido;
    if (publicos.length) filtrarPublico(modelos[atual].publico, true);
    trocarModelo(atual);
  };

  document.querySelectorAll('[data-gt-raiz]').forEach(iniciar);
  if (!window.gummieGuiaTamanhos) {
    window.gummieGuiaTamanhos = iniciar;
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-gt-raiz]').forEach(iniciar);
    });
  }
})();
